import client from './inventory-request';

// Item Classes — flat master (class_code, applicable_store_type, class_payload)
// API: GET /inventory/item-classes/
export const getItemClasses = (p) => client.get('/inventory/item-classes/', p);
// API: GET /inventory/item-classes/{id}/
export const getItemClass = (id) => client.get(`/inventory/item-classes/${id}/`);
// API: POST /inventory/item-classes/
export const createItemClass = (body) => client.post('/inventory/item-classes/', body);
// API: PATCH /inventory/item-classes/{id}/
export const updateItemClass = (id, body) => client.patch(`/inventory/item-classes/${id}/`, body);
// API: DELETE /inventory/item-classes/{id}/
export const deleteItemClass = (id) => client.delete(`/inventory/item-classes/${id}/`);
